import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { rgba } from 'polished'
import styled from '@emotion/styled'
import Link from 'src/components/Link'
import Logo from 'src/components/Logo'
import Grid from 'src/components/Grid'
import Section from 'src/components/Section'
import ConditionalRender from 'src/components/ConditionalRender'
import ScrollListener from 'src/components/ScrollListener'
import NotificationBanner from 'src/components/NotificationBanner'
import ResponsiveComponent from 'src/components/ResponsiveComponent'
import AnimatedIcon from 'src/components/AnimatedIcon'
import ContentfulRichText from 'src/components/ContentfulRichText'
import Button from 'src/components/Button'
import { colors, typography, animations, mq, util } from 'src/styles'
import Image from 'src/components/Image'

const H2 = styled.div`
  ${ typography.h2 }
  padding-bottom: 60px;
`

const H4 = styled.div`
  ${ typography.h4 }
  padding-top: 12px;
  padding-bottom: 10px;
`

const Text = styled.div`
	p {
		${ ({ textSize }) => typography[textSize] }
		margin-bottom: 0;
    max-width: 28em;
		&:first-of-type {
			margin-top: 0;
		}
		${ ({ alignment }) => alignment === 'center' && `
			margin-left: auto;
			margin-right: auto;
		` }
		${ ({ alignment }) => alignment === 'right' && `
			margin-left: auto;
		` }
	}
`

const ImageStyled = styled(Image)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const CenteredFlex = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 66.666%;
    overflow: hidden;
`

function MoreFromThePost ({ articleId }) {
  const { allContentfulBlog } = useStaticQuery(
    graphql`
			query {
				allContentfulBlog {
          edges {
            node {
              id
              displayName
              slug
              sections {
                ...Image
                ...Article
              }
              seo {
                description {
                  description
                }
                keywords
                shareImage {
                  file {
                    url
                  }
                }
              }
            }
          }
				}
			}
		`
  )

  const blog = allContentfulBlog.edges[0].node
  if (!blog) return ''
  let articles = blog && blog.sections && blog.sections
    .filter(x => x.__typename === 'ContentfulArticle')
    .filter(x => !x.internalName.includes('PLACEHOLDER'))
    .filter(x => x.id !== articleId)
    .slice(0, 3)
  if (!articles || !articles.length) return ''
  return (
    <Section theme="offwhite" setTheme="offwhite">
      <Grid
        large="1 [24] 1"
        medium="1 [12] 1"
        small="1 [12] 1"
      >
        <H2>More From {blog.displayName}</H2>
        <Grid
          large="[6] [6] [6] [6]"
          medium="[6] [6]"
          small="[12]"
          rowGap={['7vw', '7vw', '3.5vw']}
          colGap={['14px', '16px', '20px']}
        >
          {articles && articles.map(article => {
            return (
              <div>
                <CenteredFlex>
                  <ImageStyled
                    {...article.previewImage}
                  />
                </CenteredFlex>
                <div>
                  <H4>{article.title}</H4>
                </div>
                <div>
                  {article.previewText && <Text textSize='bodySmall'><ContentfulRichText richText={article.previewText.json} /></Text>}
                </div>
                <div style={{ paddingTop: '15px' }}>
                  <Button to={'/' + blog.slug + '/' + article.slug} setTheme="black" label='Explore' size='small' />
                </div>
              </div>
            )
          })}
        </Grid>
      </Grid>
    </Section>
  )
}

export default MoreFromThePost
